const searchForm = {
    dealerSiteId: $('#app').data('dealersite-id'),
    form: $('#dealerSearchForm'),
    dependentSelectElements: ['boatType', 'make', 'bikeType', 'machineType', 'vehicleType', 'partType'],
    init() {
        // Change search entity
        this.form.find('.searchElement').change(function () {
            searchForm.changeEntity(this);
        });

        // Allow only numeric input
        this.form
            .find('#priceFrom, #priceTo')
            .keyup(function () {
                commonUtils.allowInteger($(this));
            })
            .change(function () {
                searchForm.validatePriceRange($('#priceFrom'), $('#priceTo'));
            });

        // Submit form
        this.form.submit(function (event) {
            event.preventDefault();
            window.location = `${$(this).prop('action')}?${searchForm.getFormData()}`;
        });
    },
    changeEntity(changedElement) {
        if ($.inArray(changedElement.id, searchForm.dependentSelectElements) !== -1) {
            searchForm.getDependentEntity(changedElement);
        } else {
            searchForm.counter();
        }
    },
    getDependentEntity(changedElement) {
        let params = `changeType=${changedElement.name}&dealerSiteId=${this.dealerSiteId}&${this.getFormData()}`;
        $.get(Routing.generate(`advance_dealer_listing_options_${$('#site').val()}`), params, function (response) {
            for (let key in response) {
                if (Object.prototype.hasOwnProperty.call(response, key)) {
                    searchForm.form.find(`#${key}`).html(response[key]);
                }
            }
            searchForm.counter();
        });
    },
    counter() {
        $('#loadingImg_src').show();
        let params = `dealerSiteId=${this.dealerSiteId}&${this.getFormData()}`;
        $.get(Routing.generate(`advance_dealer_listing_counter_${$('#site').val()}`), params, function (data) {
            searchForm.form.find('#searchResult').val(`${Translations.show_result} (${data.total_ads})`);
            searchForm.form.find('#loadingImg_src').hide();
        });
    },
    getFormData() {
        return searchForm.form
            .find(':input')
            .filter(function (index, element) {
                return $(element).val();
            })
            .serialize();
    },
    validatePriceRange(priceFrom, priceTo) {
        if (priceFrom.val() !== '' && priceFrom.val() < 1) {
            alert(Translations.price_validate_zero);
            priceFrom.val('').trigger('change');
        }

        if (priceTo.val() !== '' && priceTo.val() < 1) {
            alert(Translations.price_validate_zero);
            priceTo.val('').trigger('change');
        }

        let filterPriceFrom = priceFrom.val() > 0 ? parseInt(priceFrom.val(), 10) : '';
        let filterPriceTo = priceTo.val() > 0 ? parseInt(priceTo.val(), 10) : '';
        if (filterPriceFrom && filterPriceTo && filterPriceFrom > filterPriceTo) {
            alert(Translations.price_validate);
            priceTo.val('').focus();
        }
    },
};

searchForm.init();
